import React, { useState } from 'react'
import {
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { format } from 'date-fns'
import { api } from '@shared/utils/api/api.util'
import { ErrorsAlert } from '@shared/components/errors-alert.component'
import { ProgressButton } from '@shared/components/progress-button.component'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
  requirementBaseID: number
  alertExpirationDate: string | null
  isResourceEdit: boolean
  onRefresh: () => void
  isCalendarDialogOpen: boolean
  setIsCalendarDialogOpen: (expanded: boolean) => void
}

const AlertRequirementAlert = ({
  requirementBaseID,
  alertExpirationDate,
  onRefresh,
  isResourceEdit,
  isCalendarDialogOpen,
  setIsCalendarDialogOpen,
}: Props) => {
  const classes = useStyles()
  const { setValue, getValues, control, watch } = useFormContext()
  const [isRemoving, setIsRemoving] = useState(false)

  if (!alertExpirationDate) {
    return null
  }

  const handleRemoveAlert = () => {
    setValue('alert', null)
  }

  return (
    <>
      <Card variant="outlined" className={classes.wrapper}>
        <div>
          <Typography color="textSecondary">
            Data wygaśnięcia alertu:{' '}
            <Typography fontWeight="bold" component="span">
              {format(new Date(alertExpirationDate), 'dd/MM/yyyy')}
            </Typography>
          </Typography>
        </div>
        <div className={classes.buttonsWrapper}>
          {isResourceEdit && !!watch('alert')?.id && (
            <Controller
              control={control}
              name="alertOverride"
              defaultValue={false}
              render={({ field: { onChange, value, ...field } }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={value}
                      onClick={() => {
                        const prevValue = watch('alertOverride')
                        onChange(!prevValue)
                      }}
                    />
                  }
                  label="Ustaw alert ponownie"
                />
              )}
            />
          )}
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setIsCalendarDialogOpen(!isCalendarDialogOpen)}
          >
            Edytuj
          </Button>
          <ProgressButton
            variant="contained"
            color="error"
            onClick={handleRemoveAlert}
            isLoading={isRemoving}
          >
            Usuń alert
          </ProgressButton>
        </div>
      </Card>
    </>
  )
}

const useStyles = makeStyles(() => {
  return {
    wrapper: {
      marginTop: 40,
      marginLeft: -35,
      padding: 16,
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    buttonsWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
    },
  }
})

export default AlertRequirementAlert
